import { Component } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DropdownControlComponent, IDropdownSelect } from '../../components/form/dropdown-control/dropdown-control.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ProductDetailsHeaderComponent } from '../../components/product/product-details-header/product-details-header.component';
import { UploadImagesComponent } from '../../components/upload-images/upload-images.component';
import { UploadedImagesListComponent } from '../../components/upload-images/uploaded-images-list/uploaded-images-list.component';
import { NotAvailableOverlayComponent } from '../../components/not-available-overlay/not-available-overlay.component';
import { ProductImageWrapperComponent } from '../../components/product/product-image-wrapper/product-image-wrapper.component';

export interface IOrderReturnDialogData {

}

@Component({
  selector: 'app-order-return-dialog',
  standalone: true,
  imports: [ButtonModule, RippleModule, DropdownControlComponent, InputTextareaModule,
     ReactiveFormsModule, ProductDetailsHeaderComponent, UploadImagesComponent, 
     UploadedImagesListComponent, NotAvailableOverlayComponent,
    ProductImageWrapperComponent],
  templateUrl: './order-return-dialog.component.html',
  styleUrl: './order-return-dialog.component.scss'
})
export class OrderReturnDialogComponent {

  public commentsControl: FormControl = new FormControl('');
  public reasonControl: FormControl = new FormControl('', [Validators.required]);
  public reasonList: IDropdownSelect[] = [
    {label: 'Broken / Defective / Warranty', value: 'test'},
    {label: 'Test1', value: 'test1'},
    {label: 'Test2', value: 'test2'},
    {label: 'Test3', value: 'test3'},
  ]

  public dialogData: IOrderReturnDialogData;
  constructor(private dialogRef: DynamicDialogRef, private config: DynamicDialogConfig){
    this.dialogData = this.config.data;
  }

  public closeDialog(){
    this.dialogRef.close()
  }

  public submitReturn(){
    this.dialogRef.close(true);
  }
}
